// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","rgpdWrapper":"_tPDF","rgpdBanner":"_2BFad","main":"jVNpL","text":"_2MLP1","acceptCookieButton":"_2dG68"};